import { createContext } from 'react';

export const DeleteTenantModalContext = createContext({
  open: (tenantId: string) => {},
});
